import { defineMessages } from "react-intl";

const messages = defineMessages({
  header: {
    id: "AQ+9Ez",
    defaultMessage: "We’ve encountered an unexpected error",
  },
  content: {
    id: "/0gMCW",
    defaultMessage:
      "Try to refresh the page or go navigate to a different page and back.",
  },
  btnDashboard: {
    id: "9mGA/Q",
    defaultMessage: "Dashboard",
    description: "button linking to dashboard",
  },
  btnRefresh: {
    id: "ypW4Mi",
    defaultMessage: "Refresh page",
    description: "button refreshing page",
  },
  or: {
    id: "OA+fw+",
    defaultMessage: "or",
    description:
      "conjunction, choice between going to dashboard or refreshing page",
  },
});

export default messages;
